/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_EmptyInputs */



/**
* | output |
* | --- |
* | "Create a dataset space to store structured tables the assistant can query." |
*
* @param {Datasets_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_empty = /** @type {((inputs?: Datasets_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie einen Datensatz-Bereich für strukturierte Tabellen, die der Assistent abfragen kann.")
	return /** @type {LocalizedString} */ ("Create a dataset space to store structured tables the assistant can query.")
});